import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';
import { aceGray, brandPrimary, mention, shuffleGray, titles } from '../../../../../styles/colors';
import { CssSelectors } from '../../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	headerContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		padding: '20px 4px 20px 4px',
	},
	headerTitle: {
		color: brandPrimary,
		margin: 0,
		padding: 0,
	},
	headerMetaRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: THEME.spacing.md,
		flexWrap: 'wrap' as const,
	},
	backButton: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		color: THEME.colors.primary.main,
		background: 'transparent',
		':has(*) > svg': {
			width: 16,
			height: 16,
			flexShrink: 0,
			pointerEvents: 'none',
		},
	},
	customizeEmailContainer: {
		display: `flex`,
		flexDirection: `column`,
		gap: THEME.spacing.md,
		flex: 1,
		boxSizing: 'border-box',
		paddingBottom: THEME.spacing.md,
		paddingTop: THEME.spacing.md,
		paddingLeft: 12,
		paddingRight: 12,
	},
	bodyEditor: {
		flexBasis: 0,
		flexGrow: 1,
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	recipientsList: {
		overflow: 'auto',
	},
	templatesList: {
		display: 'flex',
		flexDirection: 'column',
		gap: 32,
		overflow: 'auto',
		padding: '20px 20px 20px 24px',
	},
	tagTokenContainer: {
		maxHeight: 'unset',
		...CssSelectors.allChildren({
			marginLeft: '0.5rem',
		}),
	},
	contentContainer: {
		':hover': {
			cursor: 'pointer',
		},
		...CssSelectors.allChildren(
			{
				fontSize: 14,
			},
			':first-child:not(.tag):not(.saved-search)'
		),
		...CssSelectors.allChildren(
			{
				alignItems: 'center',
				display: 'flex',
				marginLeft: 8,
				textTransform: 'capitalize',
			},
			':last-child'
		),
		...CssSelectors.allChildren(
			{
				marginLeft: 0,
			},
			'.saved-search'
		),
	},
	itemsContainer: {
		':last-child': {
			marginBottom: 0,
		},
		marginBottom: 8,
	},
	pill: {
		borderRadius: 30,
		fontSize: 12,
		padding: '3px 10px',
		...CssSelectors.allChildren(
			{
				height: 13,
				marginRight: 8,
				width: 13,
			},
			'svg'
		),
	},
	emailEditorContainer: {
		backgroundColor: `${shuffleGray}80`,
		border: `1px solid ${aceGray}`,
		borderRadius: 8,
		height: 176,
		overflow: 'hidden',
		paddingLeft: 10,
	},
	emailEditorStyles: {
		width: '100%',
		height: '100%',
		overflow: 'auto',
	},
	emailSuccess: {
		paddingTop: 60,
	},
	schedulerContainer: {
		flexGrow: 1,
		minHeight: 0,
	},
	sendOptionsContainer: {
		background: mention,
		borderRadius: 8,
		color: titles,
		flexShrink: 0,
		margin: '8px 16px 16px 16px',
		overflow: 'hidden',
		padding: '16px 24px',
		...CssSelectors.allChildren(
			{
				margin: 0,
			},
			'h4'
		),
		...CssSelectors.allChildren(
			{
				fontSize: 12,
				margin: '0 0 8px 0',
			},
			'h6'
		),
	},
	sendOptionsCompleteBy: {
		padding: 0,
		justifyContent: 'flex-start',
	},
	customizeAllContentContainer: {
		padding: '20px 20px 0 24px',
	},
});
